<template>
  <div>
    <div class="acc-head" :class="{'acc-head--closed': !isOpen}" @click="toogleAcc">{{ title }}</div>
    <div v-show="isOpen">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    title: {
      type: String,
      required: true
    },
    open: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpen: this.open
    }
  },
  methods: {
    toogleAcc () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style scoped>
.acc-head {
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  color: #58595b;
  border-bottom: 1px solid #dbdbdb;
  position: relative;
  padding-bottom: 3px;
  margin-bottom: 15px;
}

.acc-head::after {
  border: solid 1px #58595b;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.6em;
  pointer-events: none;
  position: absolute;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: center;
  transform-origin: center;
  width: 0.6em;
  top: 4px;
  right: 18px;
  z-index: 4;
}

.acc-head--closed::after {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
</style>



// WEBPACK FOOTER //
// src/components/Accordion.vue